import { useEffect, useState } from "react";

function useMedia(query: string, fallback = false): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window === "undefined" ? fallback : window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

/** True from Tailwind's `lg` breakpoint up — the desktop experience. */
export function useIsDesktop(): boolean {
  return useMedia("(min-width: 1024px)");
}

/** True on coarse pointers (touch) — gates hover-only affordances like tilt. */
export function useIsTouch(): boolean {
  return useMedia("(pointer: coarse)", true);
}

export function usePrefersReducedMotion(): boolean {
  return useMedia("(prefers-reduced-motion: reduce)");
}
